<template>
    <div class="box demo-image__preview">
        <div class="image_box">
            <div class="big_btn">
                <img src="../assets/img/24x24_us_photo_see@2x.png">
            </div>
            <el-image class="img"  :src="img_api + img.image" ref="preview" :preview-src-list="[img_api + img.image]">
                        <div slot="placeholder" class="image-slot">
        加载中...
      </div></el-image>

        </div>
        <div class="box_bottom">
            <div class="box_title">{{img.name}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {
            img_api: 'https://www.gdyuanwo.com/gdyuanwo',
			api: 'http://192.168.31.41:7070/gpa/gpwx'
        }
    },
    props:['img']
};
</script>

<style scoped>
.box {
    display: flex;
    flex-direction: column;
    width: 356px;
    align-items: center;
    background-color: #F7F8FA;
    margin: 10px;
    box-shadow: 4px 6px 16px 4px rgba(0, 0, 0, 0.1);
}

.image_box {
    position: relative;
    padding: 10px;
    max-width: 330px;
    height: 235px;
}
.img{
    width: 100%;
    height: 100%;
}
.box_bottom {
    border-top: 1px solid #C8D4E1;
    width: 100%;
    display: flex;
    justify-content: center;
}

.box_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    margin: 15px;
}

.big_btn {
    position: absolute;
    left: 35%;
    top: 31%;
    width: 100px;
    height: 100px;
    z-index: 121;
     pointer-events: none; 
}

.big_btn img {
    width: 100%;
    height: 100%;
}
.image-slot{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 14px;
}
</style>
